import React from "react";
import { Box, Flex, Text, Button, Card } from "@radix-ui/themes";
import { Clock } from "lucide-react";
import { config } from "@/config/env";

const SessionExpiredPage = () => {
  return (
    <Flex
      align="center"
      justify="center"
      style={{
        minHeight: "100vh",
        background: "var(--gray-2)",
        padding: "20px",
      }}
    >
      <Card size="4" style={{ width: "100%", maxWidth: "450px" }}>
        <Flex direction="column" align="center" gap="4" py="4">
          <Box
            style={{
              padding: "16px",
              borderRadius: "50%",
              backgroundColor: "var(--red-3)",
              color: "var(--red-9)",
            }}
          >
            <Clock size={32} />
          </Box>

          <Flex direction="column" align="center" gap="2">
            <Text size="6" weight="bold">
              Session Expired
            </Text>
            <Text size="2" color="gray" style={{ textAlign: "center" }}>
              Your session has timed out due to inactivity or token expiration.
            </Text>
          </Flex>

          <Flex direction="column" gap="2" width="100%" mt="2">
            <Button
              size="3"
              variant="ghost"
              onClick={() => {
                if (window.parent !== window.self) {
                  window.parent.postMessage({ type: "exit-management" }, "*");
                } else {
                  window.location.href = config.centralAuthUrl;
                }
              }}
            >
              Return to MyAnythink
            </Button>
          </Flex>
        </Flex>
      </Card>
    </Flex>
  );
};

export default SessionExpiredPage;
